import React from 'react';
import { Stack, Button } from '@mui/material';
import InvoiceTemplateForm from './InvoiceTemplateForm';

export default function AddInvoiceTemplate({ setTemplates }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Stack justifyContent="center" alignItems="center">
        <Button variant="contained" onClick={handleOpen}>
          Dodaj szablon
        </Button>
      </Stack>
      <InvoiceTemplateForm
        open={open}
        handleClose={handleClose}
        setTemplates={setTemplates}
      />
    </>
  );
}

